import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './kpi.types';
import * as constants from './kpi.constants';

export const kpiReducer = generateResourceReducer<types.IKpi>({
  STORE: constants.STORE_KPI,
  CLEAR: constants.CLEAR_KPI,
});
